// Rollback Validator — Fase 15.9
import { getLatestRollbackMarker, runCompatibilityCheck } from '@/core/release/releaseManager'
import { buildBackupStatusReport }                        from '@/core/backup/backupOrchestrator'
export interface RollbackReadinessReport {
  timestamp: string; ready: boolean; score: number
  checks: Array<{ name: string; ok: boolean; critical: boolean; message: string }>
  blockers: string[]; rollbackPlan: string[]
}
export function validateRollbackReadiness(): RollbackReadinessReport {
  const checks: Array<{ name: string; ok: boolean; critical: boolean; message: string }> = []
  const blockers: string[] = []
  const marker  = getLatestRollbackMarker()
  const backup  = buildBackupStatusReport()
  const compat  = runCompatibilityCheck()
  const version = (import.meta.env['VITE_APP_VERSION'] as string | undefined) ?? '0.0.0'
  checks.push({ name: 'rollback_marker',   ok: !!marker,                  critical: true,  message: marker ? 'Marker: ' + marker.version : 'No rollback marker registered' })
  checks.push({ name: 'marker_validated',  ok: marker?.validated ?? false, critical: true,  message: marker?.validated ? 'Marker validated' : 'Rollback marker not validated' })
  checks.push({ name: 'backup_available',  ok: backup.restorable,          critical: false, message: backup.restorable ? 'Last backup: ' + backup.lastBackupAt : 'No restorable backup' })
  checks.push({ name: 'backup_fresh',      ok: !backup.isStale,            critical: false, message: !backup.isStale ? 'Backup fresh' : 'Backup stale (' + backup.hoursSinceBackup + 'h)' })
  checks.push({ name: 'version_tagged',    ok: version !== '0.0.0',        critical: false, message: version !== '0.0.0' ? 'Version: ' + version : 'App version not set' })
  checks.push({ name: 'compatibility',     ok: compat.compatible,          critical: false, message: compat.compatible ? 'Runtime compatible' : 'Compatibility issues' })
  if (!marker)            blockers.push('No rollback marker — register before deploy')
  if (!marker?.validated) blockers.push('Rollback marker not validated')
  const score = Math.round((checks.filter(c => c.ok).length / checks.length) * 100)
  const ready = blockers.length === 0 && checks.filter(c => c.critical).every(c => c.ok)
  return {
    timestamp: new Date().toISOString(), ready, score, checks, blockers,
    rollbackPlan: [
      '1. activateGlobalKillSwitch()',
      '2. activateEmergencyStop("rollback initiated")',
      '3. openIncident({ title: "Rollback", severity: "high" })',
      '4. Restore from last restorable backup snapshot',
      '5. Redeploy previous version tag',
      '6. validateEnvironmentConsistency()',
      '7. clearGlobalKillSwitch() + clearEmergencyStop()',
      '8. runStartupDiagnostics() + enterpriseCertificationReport()',
    ],
  }
}
